export enum ERecaptchaEventBusActionTypes {
  Validate = 'validateRecaptcha',
  Verified = 'recaptchaVerified'
}
